/**
 * Truncates text at the last word boundary before maxChars, adding an ellipsis.
 * CSS `truncate` class still acts as a pixel-level fallback.
 */
export function truncateWords(text, maxChars = 48) {
  if (!text || text.length <= maxChars) return text;
  const cut = text.lastIndexOf(' ', maxChars);
  if (cut <= 0) return text.slice(0, maxChars) + '…';
  return text.slice(0, cut) + '…';
}
